type PostStyleOption = {
  value: string;
  label: string;
  desc: string;
};

const FORMAL_KEYWORDS = [
  "resignation", "resign", "cover letter", "announcement", "report",
  "proposal", "complaint", "memo", "press release", "policy", "formal",
  "review", "audit", "notice", "apology", "statement", "brief"
];

const PERSONAL_KEYWORDS = [
  "personal", "feeling", "story", "experience", "journey", "reflect",
  "emotional", "memory", "memories", "vulnerable", "honest", "confession",
  "struggle", "gratitude", "grateful", "love", "life lesson", "milestone"
];

export function sortPostStyles<T extends PostStyleOption>(
  styles: T[],
  ideaText: string | null | undefined
): T[] {
  const text = (ideaText ?? "").toLowerCase();

  const isFormal = FORMAL_KEYWORDS.some((kw) => text.includes(kw));
  const isPersonal = !isFormal && PERSONAL_KEYWORDS.some((kw) => text.includes(kw));

  if (!isFormal && !isPersonal) return styles;

  const prioritized: string[] = isFormal
    ? ["factual", "how-to"]
    : ["personal", "storytelling"];

  const front = styles.filter((s) => prioritized.includes(s.value));
  const rest = styles.filter((s) => !prioritized.includes(s.value));

  return [...front, ...rest];
}
